import {apiPost} from "./api";

export const refetchEmployeeCache = async (targetOrg?: string): Promise<any> => {
    return await apiPost(`/batch-job/employee-cache-refetch${targetOrg ? '?TargetOrg=' + targetOrg : ''}`, {});
}
